import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "form-field" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_5 = { class: "form-field" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_8 = {
  key: 0,
  class: "error-messages"
}
const _hoisted_9 = ["disabled"]

import { useLoginForm } from '@/composables/useLoginForm'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const { formState, handleSubmit } = useLoginForm()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "login-title" }, "Login", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleSubmit) && _unref(handleSubmit)(...args)), ["prevent"])),
      class: "login-form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "username",
          class: "form-label"
        }, "Username", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formState).username) = $event)),
          type: "text",
          id: "username",
          name: "username",
          class: _normalizeClass(["form-input", { 'error': _unref(formState).errors.username.length > 0 }]),
          placeholder: "Enter your username",
          disabled: _unref(formState).isSubmitting
        }, null, 10, _hoisted_3), [
          [_vModelText, _unref(formState).username]
        ]),
        (_unref(formState).errors.username.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).errors.username, (error, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: index,
                  class: "error-text"
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("label", {
          for: "password",
          class: "form-label"
        }, "Password", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formState).password) = $event)),
          type: "password",
          id: "password",
          name: "password",
          class: _normalizeClass(["form-input", { 'error': _unref(formState).errors.password.length > 0 }]),
          placeholder: "Enter your password",
          disabled: _unref(formState).isSubmitting
        }, null, 10, _hoisted_6), [
          [_vModelText, _unref(formState).password]
        ]),
        (_unref(formState).errors.password.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).errors.password, (error, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: index,
                  class: "error-text"
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(formState).errors.general.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).errors.general, (error, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: "error-text"
              }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "login-button",
        disabled: _unref(formState).isSubmitting
      }, _toDisplayString(_unref(formState).isSubmitting ? 'Logging in...' : 'Log In'), 9, _hoisted_9)
    ], 32)
  ]))
}
}

})